"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTheme = setTheme;
var _conf = _interopRequireDefault(require("../../v-x-e-table/src/conf"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function setTheme(name) {
  var theme = name || _conf.default.theme;
  if (!theme || theme === 'default') {
    theme = 'light';
  }
  if (typeof document !== 'undefined') {
    var documentElement = document.documentElement;
    if (documentElement) {
      documentElement.setAttribute('data-vxe-ui-theme', theme);
    }
  }
}